import React from 'react';
import PropTypes from 'prop-types';
import {ControlTooltip} from '../../../ControlTooltip';

export function SpectrophotometerTooltip(props) {
  const tooltipStyle = () => {
    let style = {position: 'absolute' };
    if (props.lidOpen && props.show) {
      style.top = '0px';
    } else if (props.lidOpen && !props.show) {
      style.top = '20px';
    } else if (!props.lidOpen && props.show) {
      style.top = '70px';
    } else {
      style.top = '90px';
    }
    return style;
  };

  return (
    <ControlTooltip
      label='Spectrophotometer'
      showControls={props.show}
      tooltipStyle={tooltipStyle()}>
      {props.children}
    </ControlTooltip>
  );
}

SpectrophotometerTooltip.propTypes = {
  /**
   * Boolean set to show controls
   */
  show: PropTypes.bool,
  /**
   * Boolean set if lid is open
   */
  lidOpen: PropTypes.bool,
};

SpectrophotometerTooltip.defaultProps = {
  show: false,
  lidOpen: false,
};
